import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OneSnackBarModule } from '@one/angular-kit/modal';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { AppRouterModule } from '../../app-router.module';
import { QnSbnEservicesComponent } from './qn-sbn-eservices.component';
import { CreateNotificationModule } from '../qn-sbn-eservices/create-notification/create-notification.module';
import { NotificationModule } from '../qn-sbn-eservices/notification/notification.module';
import { RouterModule } from '@angular/router';
import { RexisSapDialogComponent } from './rexis-sap-dialog/rexis-sap-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { EmailDeliveryComponent } from './email-delivery/email-delivery.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OneFilteringChipModule } from '@one/angular-kit/indicator';
import { EmailDeliveryTableComponent } from './email-delivery-table/email-delivery-table.component';
import { OneTableModule } from '@one/angular-kit/data-table';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { OneChipModule } from '@one/angular-kit/indicator';
import { OneFormFieldModule } from '@one/angular-kit/form';
import { EmailDeliveryDetailsComponent } from './email-delivery-details/email-delivery-details.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DashboardTableComponent } from './dashboard-table/dashboard-table.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from "@angular/material/divider";
import { CustomConfirmationDialogComponent } from './custom-confirmation-dialog/custom-confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [QnSbnEservicesComponent, RexisSapDialogComponent, EmailDeliveryComponent, DashboardComponent, EmailDeliveryTableComponent, EmailDeliveryDetailsComponent, DashboardTableComponent, CustomConfirmationDialogComponent],
  exports: [QnSbnEservicesComponent],
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule, OneSnackBarModule,
    AppRouterModule, CreateNotificationModule, NotificationModule, MatFormFieldModule, MatSelectModule,
    MatInputModule, ReactiveFormsModule, FormsModule, MatDatepickerModule, MatNativeDateModule, MatCheckboxModule, OneFilteringChipModule,
    OneTableModule, MatTableModule, CdkTableModule, MatSortModule, DragDropModule, OneChipModule, MatChipsModule, OneFormFieldModule,
    MatPaginatorModule, MatMenuModule, MatDividerModule, MatDialogModule]
})
export class QnSbnEserviceModule {}
